import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirMedications } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirMedications.STARTED]: handleActionStart,
  [fetchFhirMedications.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirMedications.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.medications,
  [clearCurrentPatient]: () => initialState,
});
